const PERSONAL_EMAIL_DOMAINS = new Set([
	'aol.com',
	'gmail.com',
	'googlemail.com',
	'hotmail.com',
	'icloud.com',
	'live.com',
	'me.com',
	'msn.com',
	'outlook.com',
	'proton.me',
	'protonmail.com',
	'yahoo.co.nz',
	'yahoo.com',
	'xtra.co.nz',
]);

const trimDots = (value) => {
	let result = value;
	while (result.startsWith('.')) {
		result = result.slice(1);
	}
	while (result.endsWith('.')) {
		result = result.slice(0, -1);
	}
	return result;
};

export const normaliseLogoDomain = (value) => {
	if (!value) return '';

	let domain = String(value).trim().toLowerCase();
	domain = domain.replace('mailto:', '');

	if (domain.includes('@')) {
		const emailParts = domain.split('@');
		domain = emailParts[emailParts.length - 1];
	}

	if (domain.startsWith('https://')) {
		domain = domain.slice(8);
	} else if (domain.startsWith('http://')) {
		domain = domain.slice(7);
	}

	if (domain.startsWith('www.')) {
		domain = domain.slice(4);
	}

	domain = domain.split('/')[0].split('?')[0].split('#')[0].split(':')[0];
	domain = trimDots(domain);

	if (!domain.includes('.') || domain.includes('..')) return '';
	if (!/^[a-z0-9.-]+$/.test(domain)) return '';

	const parts = domain.split('.');
	const topLevelDomain = parts[parts.length - 1];
	if (topLevelDomain.length < 2) return '';

	return domain;
};

export const isPersonalEmailDomain = (domain) =>
	PERSONAL_EMAIL_DOMAINS.has(normaliseLogoDomain(domain));

export const getClientLogoDomain = ({ mainContact, clientRow }) => {
	const contactEmail =
		mainContact?.Email ??
		mainContact?.email ??
		mainContact?.contactEmail ??
		clientRow?.contactEmail;
	const contactDomain = normaliseLogoDomain(contactEmail);

	if (contactDomain && !isPersonalEmailDomain(contactDomain)) {
		return contactDomain;
	}

	return normaliseLogoDomain(clientRow?.website);
};

export const getBrandfetchLogoUrl = (domain) => {
	const normalisedDomain = normaliseLogoDomain(domain);
	const brandfetchClientId = process.env.REACT_APP_BRANDFETCH_CLIENT_ID;

	if (!normalisedDomain) return null;

	const params = new URLSearchParams();
	if (brandfetchClientId) {
		params.set('c', brandfetchClientId);
	}
	const query = params.toString();

	return `https://cdn.brandfetch.io/${encodeURIComponent(
		normalisedDomain,
	)}/w/128/h/128/fallback/404/type/icon${query ? `?${query}` : ''}`;
};
